const ArrowRightSvg = ( { className = "" } ) => {
	return (
		<svg
			width="100%"
			viewBox="0 0 35 50"
			className={className}>
			<path
				d="M5.00012 5L25.6062 25.0002L5.00012 45"
				stroke="currentColor"
				strokeWidth="12" />
		</svg>
	);
};
export default ArrowRightSvg;
